import { createRouter, createWebHistory } from 'vue-router'


export default createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: require('views/index.vue').default,
            children: [
                { path: '', component: require('views/top.vue').default },
                { path: '/tools/receipts/create', component: require('views/tools/receipts/create.vue').default },
                { path: '/tools/receipts-ro', component: require('views/tools/receipts/receiptListReadonly.vue').default },
                { path: '/tools/receipts', component: require('views/tools/receipts/receiptList.vue').default },
                { path: '/master/clients', component: require('views/master/clients/clients.vue').default },
                { path: '/master/account-titles', component: require('views/master/accountTitles/accountTitles.vue').default },
                { path: '/master/partner-accounts', component: require('views/master/partnerAccounts/partnerAccounts.vue').default },
                { path: '/master/tax-categories', component: require('views/master/taxCategories/taxCategories.vue').default },
                { path: '/master/tags', component: require('views/master/tags/tags.vue').default },
                { path: '/admin/menus', component: require('views/admin/menus/menus.vue').default },
                { path: '/admin/users', component: require('views/admin/users/users.vue').default },
            ]
        },
        // { path: '/403', component: require('views/403.vue').default },
        { path: '/:any*', component: require('views/404.vue').default },
        ]
});